module.exports = __webpack_public_path__ + "img/12.4c45c1a5.jpg";